import $ from 'jquery';
import 'select2';


$(() => {
  $( 'select' ).select2( {
    /*
    templateSelection: function (data) {
      if (data.id === '') { // adjust for custom placeholder values
        return 'Custom styled placeholder text';
      }

      return data.text;
    },
*/

    "language": {
      "noResults": function(){
        return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
      }
    },
    minimumResultsForSearch: -1, // hide search
    theme: "bootstrap-5",
    allowClear: true,
    width: $( this ).data( 'width' ) ? $( this ).data( 'width' ) : $( this ).hasClass( 'w-100' ) ? '100%' : 'style',
    placeholder: $( this ).data( 'placeholder' ),
  } );
});